import { SearchType, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { FieldsContainer } from '@mews-commander/ui';
import { SearchFormField } from '../../../../components';

interface CustomerFieldsProps {
    form: string;
    customerIds: string[];
}

const customerIdProps = {
    name: 'customerId',
    label: <LocalizedText textKey={TextKey.Customer} />,
    searchType: SearchType.Customer,
};

const CustomerFields = ({ form, customerIds }: CustomerFieldsProps) => (
    <FieldsContainer>
        <SearchFormField
            {...customerIdProps}
            scope={form}
            searchScope={`${form}-search-customer`}
            except={customerIds}
        />
    </FieldsContainer>
);

export default CustomerFields;
